import React, { Component } from 'react'

class TodoItem extends Component {

    state = {
        isEditing: false
    };

    toggleEditing = () => {
        this.setState({
            isEditing: !this.state.isEditing
        });
    };

    editSubmitHandler = (e) => {
        e.preventDefault();
        this.props.editTodoState(this.props.index, this.newText.value);

        //bring back to default state
        this.toggleEditing();
    };

    clickHandler = () => {
        this.props.toggleComplete(this.props.index);
    };
    
    deleteTodo = () => {
        this.props.deleteTodoFromState(this.props.index);
    };

  render() {
    //const todo = this.props.todo;
    //de-structring
      const { todo } = this.props;

      if (this.state.isEditing){
        //   return "Editing";
        return <>
            <form className="ui form edits"
            onSubmit={this.editSubmitHandler}
            >
            <input
            type="text"
            className="editsInput"
            ref={(node) => {
                this.newText = node;
            }}
            defaultValue={todo.text}
            />

            {/* cancel */}
            <div style={{float: 'right'}} className="ui small inverted red icon buttons">
            <button className="ui button"
            onClick={this.toggleEditing}
            >
            <i className="close icon icon"></i>
            </button>
            </div>

            {/* save */}
            <div style={{float: 'right'}} className="ui small inverted green icon buttons">
            <button className="ui button"
            type="submit"
            >
            <i className="check icon"></i>
            </button>
            </div>
            </form>
        </>
      }

    return (
      <>
        <ul className="item">
            <span style={{display: "inline-flex"}}>
            <i className={
              todo.completed
              ? "check icon"
              : "angle double right icon"
              }></i>
            <li
            onClick={this.clickHandler}
            className={
              todo.completed
              ? "completed"
              : ""
            }>
              {todo.text}
            </li>
            </span>
            
            {/* Delete */}
            <div style={{float: 'right'}} className="ui small inverted red icon buttons">
            <button className="ui button"
            onClick={this.deleteTodo}
            >
                <i className="trash alternate icon"></i>
            </button>
            </div>

            {/* Edit */}
            <div style={{float: 'right'}} className="ui small inverted green icon buttons">
            <button className="ui button"
            onClick={this.toggleEditing}
            >
                <i className="edit outline icon"></i>
            </button>
            </div>
        </ul>
      </>
    )
  }
}

export default TodoItem;
